import { SupportedLanguage } from '@/scripts/root/language'

export const languageFlags: Record<SupportedLanguage, string> = {
  en: '🇺🇸',
  de: '🇩🇪',
  es: '🇪🇸',
  fr: '🇫🇷',
  pt: '🇵🇹',
  'zh-TW': '🇹🇼',
  it: '🇮🇹',
  id: '🇮🇩',
  th: '🇹🇭',
  ar: '🇸🇦',
  kr: '🇰🇷',
  jp: '🇯🇵',
}
